import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RevenueService } from "../services/revenue.service";
import { RevenueSetting, UpdateRevenueSettingDto } from "../dto/index.dto";

export const useGetRevenueSettingsHook = () => {
  return useQuery({
    queryKey: ["revenue", "settings"],
    queryFn: () => RevenueService.getSettings(),
  });
};

export const useUpdateRevenueSettingHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      type,
      data,
    }: {
      type: string;
      data: UpdateRevenueSettingDto;
    }) => RevenueService.updateSetting(type, data),
    onSuccess: (updated) => {
      queryClient.setQueryData<RevenueSetting[] | undefined>(
        ["revenue", "settings"],
        (old) =>
          old ? old.map((s) => (s.type === updated.type ? updated : s)) : old
      );
    },
  });
};

export const useGetRevenueStatsHook = () => {
  return useQuery({
    queryKey: ["revenue", "stats"],
    queryFn: () => RevenueService.getStats(),
  });
};
